import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpParamsUtils } from 'ib/internetbank-core/utils/http-params.utils';


import { TechnicalAlert } from './technical-alert';

@Injectable({ providedIn: 'root' })
export class TechnicalAlertsService {
	constructor(private http: HttpClient) { }

	public getTechnicalAlerts(
		placeCode: 'PRELOGIN' | 'MAINPAGE',
	): Observable<Array<TechnicalAlert>> {
		return this.http.get<Array<TechnicalAlert>>('rest/common/notice', {
			params: HttpParamsUtils.createHttpParams({
				placeCode,
				systemCode: 'INTERNETBANK',
			}),
		});
	}
}
